import service from '@/services/link/link'

const getDefaultState = () => ({
  link: {
    _id: '',
    state: '',
    consecutivo: null
    // factura: {}
  },
  lista: [],
  pageInfo: {},
  currentRow: null
})

export const state = () => getDefaultState()

export const mutations = {
  SET_LINK: (state, link) => (state.link = link),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LISTA: (state, obj) => {
    state.lista = [...new Set([...state.lista.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  }
}

export const actions = {
  readLink: ({ commit }, { link, consecutivo }) =>
    service.readLink(link, consecutivo).then(response => {
      if (response?.state === 'PENDIENTE') service.setLinkState(response._id, 'CONSULTADO')

      commit('SET_LINK', response)

      return response
    }),
  create: ({ rootGetters }, link) => service.create({ ...link, _idEmisor: rootGetters['facturacion/emisorStore/get_Id'] }),
  setLinkState: (_, { _id, state }) => service.setLinkState(_id, state),
  resetLista: ({ state }) => {
    state.lista = []
    state.pageInfo = {}
  },
  readLinksByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetLista')

    return service.readLinksByEmisor(await rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(result => {
      commit('SET_LISTA', result)
    })
  }
}

export const getters = {}
